import {getData} from "../utils/StorageUtil";
import Global from "../utils/Global";
import {isEmpty} from "../utils/Utilities";

let key = getData(Global.LANGUAGE);
if(isEmpty(key)){
    key = Global.DEFAULT_LANGUAGE
}
const translation = require('./Label.'+key+'.js')

const varToString = varObj => Object.keys(varObj)[0]

const message = function (key) {
    if(!key){
        key = varToString({key})
    }
    key = key.replace(/ /g, "");
    
    let res = translation[key]
    if(!res){
        res = key
        if(res.length>0){
            res = res.split(/(?=[A-Z])/).join(" ")
            res = res.charAt(0).toUpperCase() + res.slice(1)
            let concatStart = 0
            let concatEnd = 0
            let found = false ;
            let isShorten = true ;
            for (let i = 0; i < res.length; i++){
                let kar = res.charAt(i);
                if(kar!=' ') {
                    if (kar === res.charAt(i).toUpperCase()) {
                        if(!found){
                            concatStart = i;
                        }
                        concatEnd = i;
                        found = true
                    }else{
                        isShorten = false ;
                        break
                    }
                }
            }
            if(!isShorten) {
                res = replaceSpacesInRange(res, concatStart, concatEnd - 1)
            }else{
                res = replaceSpacesInRange(res, 0, res.length-1)
            }
        }
    }
    return res
}

function replaceSpacesInRange(str, start, end) {
    const before = str.slice(0, start);
    const middle = str.slice(start, end).replace(/ /g, ""); // remove all spaces
    const after = str.slice(end);

    return before + middle + after;
}

const IN = "in";
const EN = "en";

export const LANGUAGE = {
    "in":{id:1, name:"Bahasa Indonesia", key:IN, flag:"https://flag.pk/flags/4x3/ID.svg"},
    "en":{id:2, name:"English", key:EN, flag:"https://flag.pk/flags/4x3/US.svg"}
}

export const LANGUAGES = [LANGUAGE[IN],LANGUAGE[EN]]

export const GENDERS = [
    {
        id:1,
        key:"MALE",
        name:translation.Male
    },
    {
        id:2,
        key:"FEMALE",
        name:translation.Female
    }
]
export const SUBMISSION_ORDER = [
    {
        id:true,
        name:translation.InspectionMustBeingOrderedSequentially
    },
    {
        id:false,
        key:"FEMALE",
        name:translation.InspectionCanBeAppliedMoreThanOneSimultaneously
    }
]


// const content = Object.freeze(translation, GENDERS)
const label = Object.assign(message, translation)
export default label
